<div class="p-lg-5 m-lg-5">
    <h3 class="text-danger">Your Subscription / Free Trial is Expired !</h3>
    <button (click)="pay()" type="button" class="btn btn-primary bg-primary w-100">
        Purchase Plan
    </button>
    <button (click)="logout()" type="button" class="btn btn-danger bg-danger w-100 my-2">
        Logout
    </button>
</div>